module.exports = __webpack_public_path__ + "static/media/nagaland.8a556e0a.png";